import { Spin, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ProjectBudgetTab from "../../components/research_development/ProjectBudgetTab";
import ProjectInfoTab from "../../components/research_development/ProjectInfoTab";
import PurchaseRequestTab from "../../components/research_development/PurchaseRequestTab";
import { useGetResearchProject } from "../../query/ReseachQuery";
import NotFound from "../NotFound/NotFound";
import ProjectDocument from "../../components/research_development/ProjectDocument";
import ProjectPhasesTab from "../../components/research_development/ProjectPhasesTab";

const ProjectDetail = () => {
  const { alias } = useParams<{ alias: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("info");
  const { data: project, isLoading } = useGetResearchProject(alias);

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (
      tab &&
      ["info", "budget", "purchase-request", "document", "phase"].includes(tab)
    ) {
      setActiveTab(tab);
    }
  }, [searchParams]);

  if (isLoading || !project) {
    return (
      <div className="p-4 flex justify-center items-center h-screen">
        <Spin size="large" />
      </div>
    );
  }
  if (!alias) {
    return <NotFound />;
  }

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <div className="text-xl font-bold">
          {project?.project} - {project?.projectName}
        </div>
        <div className="flex gap-2 items-center text-sm">
          <span>Ngày tạo: {project?.requestDate}</span>
          <span>|</span>
          <span>Người tạo: {project?.saleAdInCharge}</span>
        </div>
      </div>
      <Tabs
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
          const params = new URLSearchParams(searchParams);
          params.set("tab", key);
          setSearchParams(params);
        }}
        items={[
          {
            key: "info",
            label: "Thông tin chung",
            children: <ProjectInfoTab project={project} />,
          },
          {
            key: "phase",
            label: "Timeline",
            children: <ProjectPhasesTab alias={alias} />,
          },
          {
            key: "budget",
            label: "Ngân sách",
            children: <ProjectBudgetTab alias={alias} />,
          },
          {
            key: "purchase-request",
            label: "Hàng đặt mua",
            children: <PurchaseRequestTab alias={alias} />,
          },
          {
            key: "document",
            label: "Tài liệu",
            children: <ProjectDocument alias={alias} />,
          },
        ]}
      />
    </div>
  );
};

export default ProjectDetail;
